import { render, staticRenderFns } from "./AboutItemRight.vue?vue&type=template&id=3bda1034&"
import script from "./AboutItemRight.vue?vue&type=script&lang=js&"
export * from "./AboutItemRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports